<template>
  <div>
    <v-row dense>
      <v-col cols="12">
        <v-subheader class="grey lighten-4 text--primary">
          <v-icon left>mdi-map-marker</v-icon>
          Endereço nacional
        </v-subheader>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" sm="3">
        <v-text-field
          dense
          outlined
          hide-details
          label="CEP"
          v-mask="['#####-###']"
          class="required rounded-tag-small"
          :error="$v.endereco.cep.$error"
          @blur="$v.endereco.cep.$touch()"
          v-model="endereco.cep"
          @change="onChangeCep"
        />
      </v-col>
      <v-col cols="12" sm="6">
        <v-text-field
          outlined
          dense
          hide-details
          label="Logradouro"
          maxlength="100"
          class="required rounded-tag-small"
          :error="$v.endereco.rua.$error"
          @blur="$v.endereco.rua.$touch()"
          v-model="endereco.rua"
        />
      </v-col>
      <v-col cols="12" sm="3">
        <v-text-field
          outlined
          dense
          class="rounded-tag-small"
          hide-details
          label="Número"
          maxlength="6"
          v-mask="['######']"
          v-model="endereco.numero"
        />
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" sm="5">
        <v-text-field
          outlined
          dense
          hide-details
          label="Bairro"
          maxlength="60"
          class="required rounded-tag-small"
          :error="$v.endereco.bairro.$error"
          @blur="$v.endereco.bairro.$touch()"
          v-model="endereco.bairro"
        />
      </v-col>
      <v-col cols="12" sm="3">
        <px-autocomplete-uf outlined
                            dense
                            hide-details
                            class="required rounded-tag-small"
                            :error="$v.endereco.estado.$error"
                            @blur="$v.endereco.estado.$touch()"
                            v-model="endereco.estado"
                            @change="onChangeUf"
        />
      </v-col>
      <v-col cols="12" sm="4">
        <px-autocomplete-municipio
          outlined
          dense
          hide-details
          class="required rounded-tag-small"
          :uf="endereco.estado"
          :disabled="!endereco.estado"
          :error="$v.endereco.municipio.$error"
          @blur="$v.endereco.municipio.$touch()"
          v-model="endereco.municipio"/>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import validationMixin from '@/mixins/validation-mixin';
import CepService from '@/api/cep-service';
import { onlyNumbers } from '@/utils/regex-utils';

const CEP_LENGTH = 9;

export default {
  mixins: [validationMixin],
  props: {
    endereco: {
      type: Object,
      required: true,
      default: () => ({
        estado: null,
        municipio: null,
        cep: null,
        rua: null,
        numero: null,
        complemento: null,
        bairro: null,
      }),
    },
  },
  methods: {
    clearEndereco() {
      this.endereco.rua = '';
      this.endereco.bairro = '';
      this.endereco.estado = null;
      this.endereco.municipio = null;
    },
    handleEndereco(data) {
      if (!data || data.erro) {
        this.clearEndereco();
        return;
      }

      this.endereco.rua = data.rua;
      this.endereco.bairro = data.bairro;
      this.endereco.estado = data.estado;
      this.endereco.municipio = data.municipio;
    },
    getCepData(cep) {
      CepService.get(cep)
        .then(({ data }) => {
          this.handleEndereco(data);
        });
    },
    onChangeCep() {
      if (!this.endereco.cep || this.endereco.cep.length !== CEP_LENGTH) {
        return;
      }
      this.getCepData(onlyNumbers(this.endereco.cep));
    },
    onChangeUf() {
      this.endereco.municipio = null;
    },
  },
  created() {
    this.endereco.pais = {
      id: 76,
      nome: 'Brasil',
      sigla: 'BRA',
      codigoBacen: 1058,
    };
  },
  validations: {
    endereco: {
      cep: {
        required,
      },
      rua: {
        required,
      },
      bairro: {
        required,
      },
      estado: {
        required,
      },
      municipio: {
        required,
      },
    },
  },
};
</script>
